import React from "react";
import Chart from "react-apexcharts";

const SubscriptionAndCollectionView = () => {
  const chartOptions = {
    chart: {
      id: "column-chart",
      toolbar: {
        show: true,
      },
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    yaxis: [
      {
        title: {
          text: "Subscription",
        },
      },
      {
        opposite: true,
        title: {
          text: "Collection",
        },
      },
    ],
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "50%",
        endingShape: "rounded",
      },
    },
    colors: ["#008FFB", "#00E396"],
    tooltip: {
      enabled: true,
    },
  };

  const chartSeries = [
    {
      name: "Subscription",
      data: [10, 20, 5, 15, 16, 20, 13, 8, 11, 12, 6, 12],
    },
    {
      name: "Collection",
      data: [
        1000, 2000, 500, 2000, 1600, 3000, 1300, 800, 1100, 1200, 600, 1200,
      ],
    },
  ];

  return (
    <div>
      <Chart
        options={chartOptions}
        series={chartSeries}
        type="bar"
        height={350}
      />
    </div>
  );
};

export default SubscriptionAndCollectionView;
